module.exports = __webpack_public_path__ + "static/media/hamsa.5aca2828.svg";